import XLSX from "xlsx";

export default class Excel {
  /**
   *
   * @param {*} file
   * @param {*} sheetKeyList
   */
  constructor(file, sheetKeyList) {
    this._file = file;
    this._headerKey = sheetKeyList;
    this._sheet = null;
    this._wb = null;
  }

  /**
   * 엑셀 다운로드 시작
   */
  initSheet() {
    this._wb = XLSX.utils.book_new();
  }

  /**
   * 시트 생성 및 추가
   * @param {*} data
   */
  addSheet(data) {
    let headerValue = Object.values(this._headerKey);
    let sheetData = this.changeSheetHeader(data);
    if (this._sheet === null) {
      this._sheet = XLSX.utils.json_to_sheet(sheetData, {
        header: headerValue,
      });
    } else {
      XLSX.utils.sheet_add_json(this._sheet, sheetData, {
        origin: -1,
        skipHeader: true,
        header: headerValue,
      });
    }
  }

  /**
   * 종료
   */
  endSheet(fileName) {
    XLSX.utils.book_append_sheet(this._wb, this._sheet, fileName);
    XLSX.writeFile(this._wb, fileName + ".xlsx");
    this._sheet = null;
    this._wb = null;
  }

  /**
   * 우선 첫번째 시트만 가져옴 json으로 나중에 확장필요하면 하기
   */
  async getJson() {
    let reader = new FileReader();
    reader.readAsBinaryString(this._file);
    let result = await new Promise((resolve) => {
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, { type: "binary" });
        this._sheetNameList = wb.SheetNames; // 시트 이름 목록 가져오기
        this._firstSheetName = this._sheetNameList[0]; // 첫번째 시트명
        this._firstSheet = wb.Sheets[this._firstSheetName];
        let resultSheet = XLSX.utils.sheet_to_json(this._firstSheet);
        if (this._headerKey) {
          resultSheet = this.changeSheetHeader(resultSheet);
        }

        resolve(resultSheet);
      };
    });
    return result;
  }
  async getNewJson(type, durationType, durationCount, durationKind) {
    let reader = new FileReader();
    reader.readAsBinaryString(this._file);
    let result = await new Promise((resolve) => {
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, { type: "binary" });
        this._sheetNameList = wb.SheetNames; // 시트 이름 목록 가져오기
        this._firstSheetName = this._sheetNameList[0]; // 첫번째 시트명
        this._firstSheet = wb.Sheets[this._firstSheetName];
        let resultSheet = XLSX.utils.sheet_to_json(this._firstSheet);
        const json = XLSX.utils.sheet_to_json(this._firstSheet, { header: 1 });
        const excel_key_list = json[0];
        let title_key_list = [
          "product_code",
          "variant_code",
          "product_name",
          "variant_name",
          "activate_type",
          "duration_type",
          "duration",
          "serial_number",
        ];
        if (type == "auto") {
          title_key_list = [
            "product_code",
            "variant_code",
            "product_name",
            "variant_name",
            "activate_type",
            "duration_type",
            "duration",
            "number_of_serial",
          ];
        } else if (type == "digital") {
          title_key_list = ["product_code", "variant_code", "product_name", "variant_name", "serial_number"];
        } else if (type == "header") {
          title_key_list = Object.values(this._headerKey);
        }
        this._headerKey = {};
        for (let i = 0; i < excel_key_list.length; i++) {
          this._headerKey[excel_key_list[i]] = title_key_list[i];
        }
        if (this._headerKey) {
          resultSheet = this.changeNewSheetHeader(resultSheet, excel_key_list, title_key_list, durationType, durationCount, durationKind);
        }
        resolve(resultSheet);
      };
    });
    return result;
  }
  changeSheetHeader(sheet) {
    let result = [];
    sheet.forEach((list) => {
      let data = {};
      for (let k in list) {
        for (let h in this._headerKey) {
          if (h === k) {
            data[this._headerKey[h]] = list[k];
          }
        }
      }
      if (data !== null) {
        result.push(data);
      }
    });
    return result;
  }
  changeNewSheetHeader(sheet, header_key_list, title_code_list, durationType, durationCount, durationKind) {
    let result = [];
    for (const data of sheet) {
      let param = {};
      for (const index in header_key_list) {
        param[title_code_list[index]] = data[header_key_list[index]];
      }
      if (!param["activate_type"]) {
        param["activate_type"] = durationType;
      }
      if (!param["duration_type"]) {
        param["duration_type"] = durationKind;
      }
      if (!param["duration"]) {
        param["duration"] = durationCount;
      }
      result.push(param);
    }
    return result;
  }
}
